// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__oUHOM","main1":"Layout_main1__A2JHi","left-panel":"Layout_left-panel__dKI52","right-panel":"Layout_right-panel__jdcvE"};